import React, { useEffect, lazy, Suspense } from "react";
import { Routes, Route, Navigate, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import { Box } from "@mui/material";
import Navigation from "../Layouts/Navigation/Navigation";
import SideBar from "../Layouts/SideBar/SideBar";
import classes from "./index.module.css";
import PrivateRoute from "./PrivateRoute";
import Loader from "../CommonComponents/Loader/Loader";
import Footer from "../Layouts/Footer/Footer";
import BottomNavigation from "../Layouts/BottomNavigation/BottomNavigation";
import ScrollTopGlobal from "../CommonComponents/ScrollTop";
import CaseDescription from "../Pages/CaseManagement/Actions/CaseDescription/CaseDescription";
import InvoiceInfo from "../Pages/invoiceInfo/InvoiceInfo";
import { publicPaths } from "../constants/utils";

const Dashboard = lazy(() => import("../Pages/Dashboard/Dashboard"));
const CaseManagement = lazy(
  () => import("../Pages/CaseManagement/CaseManagement")
);

const Approval = lazy(() => import("../Pages/Approval/Approval"));
const LoginPage = lazy(() => import("../Pages/Login/LoginPage"));
const CreateCase = lazy(() => import("../Pages/CreateCase/CreateCase"));
const FMRFormComponent = lazy(
  () => import("../CommonComponents/CustomizedForm/FMRFormComponent")
);
const MisReports = lazy(() => import("../Pages/MisReports/MisReports"));
const Assignblock = lazy(
  () => import("../CommonComponents/AssignBlocks/Assignblock")
);
const CaseSearch = lazy(() => import("../Pages/CaseSearch/CaseSearch"));
const FeedbackForm = lazy(() => import("../Pages/SMSFeedback/FeedbackForm"));
const VendorOnboardingMain = lazy(
  () => import("../Pages/VendorManagement/VendorOnboardingMain")
);
const CaseSearchTable = lazy(
  () => import("../Pages/CaseSearch/CaseSearchTable")
);
const CaseSearchView = lazy(() => import("../Pages/CaseSearch/CaseSearchView"));
const CaseHistory = lazy(() => import("../Pages/CaseHistory/CaseHistory"));

const Index = () => {
  const { token: isAuthenticated } = useSelector((state) => state.loginSlice);
  const isLoadingState = useSelector(
    (state) => state.loginSlice.isLoadingState
  );
  const userRole = useSelector(
    (state) => state?.loginSlice?.userData?.currentRoleName
  );
  const location = useLocation();

  useEffect(() => {
    if (!isAuthenticated === false) {
    }
  }, [isAuthenticated]);

  return !publicPaths.includes(location?.pathname) ? (
    <div
      className={classes["main-container"]}
      style={
        !location.pathname.includes("caseHistory") ? { overflow: "hidden" } : {}
      }
    >
      {isLoadingState && <Loader />}
      {isAuthenticated && (
        <Navigation
          disabled={["MIS", "MRA"].includes(userRole)}
          isUserMenuIconVisible={true}
        />
      )}
      {isAuthenticated && <BottomNavigation />}
      <div className={classes["sidebar-and-content-conatiner"]}>
        {isAuthenticated && <SideBar />}
        <div
          className={`${classes["main-contents"]} ${classes["main-content"]}`}
        >
          <div
            className={classes["router-conatiner"]}
            style={{ marginLeft: ["MIS", "MRA"].includes(userRole) ? 0 : "8%" }}
          >
            <Suspense fallback={<Loader />}>
              <Routes>
                <Route element={<PrivateRoute />}>
                  <Route path="/home" element={<Dashboard />} />
                  <Route path="/assignBlock" element={<Assignblock />} />
                  <Route
                    path="/caseDescription"
                    element={<CaseDescription />}
                  />
                  <Route path="/invoice-approval" element={<Approval />} />
                  <Route
                    path="/re-assign/:vendorId/:reassignType"
                    element={<Assignblock isReassign />}
                  />
                  <Route path="/caseManagement" element={<CaseManagement />} />
                  <Route
                    path="/vendorOnboarding"
                    element={<VendorOnboardingMain />}
                  />
                  <Route path="/createCase" element={<CreateCase />} />
                  <Route path="/approval" element={<Approval />} />
                  <Route path="/reports" element={<MisReports />} />
                  <Route
                    path="/fmr-report-download"
                    element={<FMRFormComponent />}
                  />
                  <Route path="/caseSearch" element={<CaseSearch />} />
                  <Route
                    path="/caseSearchResult"
                    element={<CaseSearchTable />}
                  />
                  <Route path="/caseSearchView" element={<CaseSearchView />} />
                  <Route
                    path={"/caseSearchView"}
                    element={<CaseSearchView />}
                  />
                  <Route
                    path={"/caseHistory"}
                    element={<CaseHistory />}
                  />
                </Route>
                <Route path="/login" element={<LoginPage />} />
                <Route path="/" element={<Navigate to={"/home"} />} />
                <Route
                  path="*"
                  element={
                    <Box
                      sx={{
                        marginTop: "30px",
                        textAlign: "center",
                        color: "#00000E6",
                      }}
                    >
                      <h1>Coming Soon</h1>
                    </Box>
                  }
                />
              </Routes>
            </Suspense>
          </div>
        </div>
      </div>
      {isAuthenticated && <ScrollTopGlobal />}
      <Footer />
    </div>
  ) : (
    <Suspense fallback={<Loader />}>
      <Routes>
        <Route path={"/feedback"} element={<FeedbackForm />} />
        <Route path={"/invoice-info"} element={<InvoiceInfo />} />
      </Routes>
    </Suspense>
  );
};

export default Index;
